"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.147 1.254 24.124 25.35.724-.689-3.33-3.499a7.294 7.294 0 0 0-.606-13.971A9.118 9.118 0 0 0 8.25 5.164L3.872.564l-.725.69Zm5.797 4.64 14.95 15.711a6.294 6.294 0 0 0-.076-12.19l-.562-.14-.158-.556A8.118 8.118 0 0 0 8.944 5.894ZM7.522 8.606c.117-.39.263-.769.436-1.132l-.733-.77a9.056 9.056 0 0 0-.661 1.614 7.293 7.293 0 0 0 1.145 14.493H22.29c.086 0 .172-.001.257-.004l-.947-.995H7.709a6.291 6.291 0 0 1-.99-12.506l.622-.098.18-.602Z",
    fill: "#fff"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgError);
var _default = exports["default"] = Memo;